var _DegreeLayout, _B2BLayout, _PremiumLayout, _PremiumTrialLayout, _NewCoursesSlider, _NewCoursesSlider2;
import cn from "clsx";
import NewCoursesSlider from "./components/NewCoursesSlider";
import { useLearnLastActivityContext } from "./hooks";
import B2BLayout from "./layouts/B2B/B2BLayout";
import DegreeLayout from "./layouts/Degree";
import PayGLayout from "./layouts/PayG";
import PremiumLayout from "./layouts/Premium";
import PremiumTrialLayout from "./layouts/PremiumTrial";
import { jsx as _jsx } from "react/jsx-runtime";
var LearnLastActivity = function LearnLastActivity(_ref) {
  var classNameProp = _ref.className;
  var _useLearnLastActivity = useLearnLastActivityContext(),
    me = _useLearnLastActivity.me,
    error = _useLearnLastActivity.error,
    isDark = _useLearnLastActivity.isDark,
    source = _useLearnLastActivity.source,
    loading = _useLearnLastActivity.loading,
    catalogUrl = _useLearnLastActivity.catalogUrl,
    totalCount = _useLearnLastActivity.totalCount,
    studentType = _useLearnLastActivity.studentType,
    userDashboardUrl = _useLearnLastActivity.userDashboardUrl,
    hideSliderNewCourses = _useLearnLastActivity.hideSliderNewCourses,
    className = _useLearnLastActivity.className,
    disableRedirections = _useLearnLastActivity.disableRedirections,
    _useLearnLastActivity2 = _useLearnLastActivity.containerType,
    containerType = _useLearnLastActivity2 === void 0 ? 'default' : _useLearnLastActivity2,
    onGoToPlayer = _useLearnLastActivity.onGoToPlayer,
    onEditTastes = _useLearnLastActivity.onEditTastes,
    onGoToProject = _useLearnLastActivity.onGoToProject,
    onGoToCatalog = _useLearnLastActivity.onGoToCatalog,
    onEnrollToCourse = _useLearnLastActivity.onEnrollToCourse,
    onGoToCourseDetail = _useLearnLastActivity.onGoToCourseDetail,
    onGoToUserDashboard = _useLearnLastActivity.onGoToUserDashboard;
  var renderContentByStudentType = {
    anonymous: function anonymous() {
      return undefined;
    },
    degree: function degree() {
      return _DegreeLayout || (_DegreeLayout = /*#__PURE__*/_jsx(DegreeLayout, {}));
    },
    b2b: function b2b() {
      return _B2BLayout || (_B2BLayout = /*#__PURE__*/_jsx(B2BLayout, {}));
    },
    premium: function premium() {
      return _PremiumLayout || (_PremiumLayout = /*#__PURE__*/_jsx(PremiumLayout, {}));
    },
    'premium-trial': function premiumTrial() {
      return _PremiumTrialLayout || (_PremiumTrialLayout = /*#__PURE__*/_jsx(PremiumTrialLayout, {}));
    },
    register: function register() {
      return _NewCoursesSlider || (_NewCoursesSlider = /*#__PURE__*/_jsx(NewCoursesSlider, {
        showTitle: true,
        withContainer: true,
        "data-testid": "new-courses-slider-section"
      }));
    },
    payg: function payg() {
      var _me$catalogSubcategor;
      if (!loading && !error && !totalCount) {
        return _NewCoursesSlider2 || (_NewCoursesSlider2 = /*#__PURE__*/_jsx(NewCoursesSlider, {
          showTitle: true,
          withContainer: true,
          "data-testid": "new-courses-slider-section"
        }));
      }
      return /*#__PURE__*/_jsx(PayGLayout, {
        containerType: containerType,
        isDark: isDark,
        me: me,
        tastes: ((_me$catalogSubcategor = me.catalogSubcategoryTastes) === null || _me$catalogSubcategor === void 0 ? void 0 : _me$catalogSubcategor.map(function (sc) {
          return sc.name;
        })) || [],
        onEditTastes: onEditTastes,
        amplitudePageName: source,
        disableRedirections: disableRedirections,
        onGoToCatalog: onGoToCatalog,
        catalogUrl: catalogUrl,
        onGoToUserDashboard: onGoToUserDashboard,
        userDashboardUrl: userDashboardUrl,
        onEnrollToCourse: onEnrollToCourse,
        onGoToCourseDetail: onGoToCourseDetail,
        onGoToPlayer: onGoToPlayer,
        onGoToProject: onGoToProject,
        "data-testid": "my-courses-section"
      });
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: cn(!hideSliderNewCourses && 'tw-w-full tw-text-neutral-light-100 dark:tw-text-neutral-light-800', className, classNameProp),
    "data-testid": "learn-last-activity-section",
    children: renderContentByStudentType[studentType]()
  });
};
export default LearnLastActivity;